import type { isSupported } from '@loomhq/loom-sdk';

type ReturnValue = ReturnType<typeof isSupported>;

export async function isSdkSupported(): ReturnValue {
  const module = await import('@loomhq/loom-sdk');

  const { isSupported } = module;

  return isSupported();
}
